export default __webpack_public_path__ + "images/9b9d5c0bc4b4fbc87061928e5a14fc1d.svg";